module.exports = __webpack_public_path__ + "img/despacho03.fafe0022.png";